module.exports = __webpack_public_path__ + "img/07.5f51c545.jpg";